import styled from 'styled-components';

import { Button, Form, Input, Select, message, Checkbox, Radio } from 'antd';
import { t } from 'i18next';
import { userResetPassword } from '../../../api/User';
import { CustomInput } from '../../../components/CustomForm';

const SetPasswordContainer = styled.div`
  padding: 20px;
`;

const style = {
  height: '42px',
  borderRadius: '6px',
};

const SetPassword = () => {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const { code, data, msg } = await userResetPassword(values);
      if (code) {
        message.success('success');
        onReset();
      } else {
        message.error(msg ? msg : data.msg || 'Error');
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const onReset = () => {
    form.resetFields();
  };

  const onFill = () => {
    form.setFieldsValue({});
  };

  const onFinishFailed = (errorInfo) => {
    message.error('validateField');
    // console.log('Failed:', errorInfo);
  };

  return (
    <SetPasswordContainer>
      <Form
        form={form}
        labelAlign="left"
        requiredMark={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className={'set-password-form'}
        labelCol={{
          sm: {span: 8},
          md: {span: 6},
          lg: {span: 5},
          xl: {span: 4},
          xxl: {span: 3},
        }}
      >
        <Form.Item
          label={t('user_center.setPassword.Old Password')}
          name="password"
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 14 },
            md: { span: 12 },
            lg: { span: 10 },
            xl: { span: 9 },
            xxl: { span: 8 },
          }}
          rules={[
            { required: true, message: 'Please input your old password!' },
          ]}
        >
          <CustomInput type={'password'} style={style} />
        </Form.Item>
        <Form.Item
          label={t('user_center.setPassword.New password')}
          name="new_password"
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 14 },
            md: { span: 12 },
            lg: { span: 10 },
            xl: { span: 9 },
            xxl: { span: 8 },
          }}
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <CustomInput type={'password'} style={style} />
        </Form.Item>
        <Form.Item
          label={t('user_center.setPassword.Confirm Password')}
          name="new_password_confirmation"
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 14 },
            md: { span: 12 },
            lg: { span: 10 },
            xl: { span: 9 },
            xxl: { span: 8 },
          }}
          dependencies={['new_password']}
          rules={[
            { required: true, message: 'Please input your password!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  new Error('The two passwords that you entered do not match!')
                );
              },
            }),
          ]}
        >
          <CustomInput type={'password'} style={style} />
        </Form.Item>
        <Form.Item
            wrapperCol={{
              xs: {
                offset: 0,
              },
              sm: {
                offset: 8,
              },
              md: {
                offset: 6,
              },
              lg: {
                offset: 5,
              },
              xl: {
                offset: 4,
              },
              xxl: {
                offset: 3,
              },
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: '#18EAC4',
                color: '#000000',
                borderColor: '#18EAC4',
                borderRadius: '4px',
              }}
            >
              {t('user_center.setPassword.submit')}
            </Button>
            {/* <Button
              type="primary"
              onClick={onReset}
              style={{
                marginLeft: '10px',
                backgroundColor: '#18EAC4',
                color: '#000000',
                borderColor: '#18EAC4',
              }}
            >
              {t('user_center.PersonalProfile.Reset')}
            </Button> */}
          </Form.Item>
      </Form>
    </SetPasswordContainer>
  );
};

export default SetPassword;
